import type { IconData } from '@stacksjs/iconify-core'

export const share: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M68.146 496H16V235.333a114.2 114.2 0 0 1 12.025-51.309A136.27 136.27 0 0 1 152 104h136.557V16h42.361l163.709 163.71L330.337 344h-41.78v-88h-88.812a85.4 85.4 0 0 0-81.993 62.244ZM152 136a104.22 104.22 0 0 0-94.923 61.443l-.292.614A82.45 82.45 0 0 0 48 235.333v213.81l38.93-139.5A117.5 117.5 0 0 1 199.745 224h120.812v84.525L449.373 179.71L320.557 50.894V136Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default share
